export const IDS = 'conceptIds';
export const CONCEPT_FAMILIES = 'conceptFamilyIds';
export const PROMO_CODE = 'promoCodeId';
export const CHANNELS = 'channels';
export const LANGUAGE = 'languageId';
export const ENHANCERS = 'enhancerIds';
export const TAGS = 'tagIds';
export const JIRA_TASK = 'jiraTask';
export const REQUESTED_BY = 'requestedById';
export const POSTFIX = 'postfix';
export const OUTSOURCE_STUDIO_ID = 'outsourceStudioId';
export const DESIGNER = 'authorId';
export const DESCRIPTION = 'description';
export const ATTACHMENTS = 'attachments';
export const STATE_SCHEDULES = 'stateSchedules';
export const AI_GENERATED = 'isAICreated';
export const PRODUCTION_TYPE = 'productionTypeId';
